// utils/exportToExcel.ts
import XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";

export const exportToExcel = (jsonData, fileName, title) => {
  // Insert one blank row between the last employee row and the Total row
  // (assumes the Total row is always the last item in jsonData)
  const rows = [...jsonData];
  if (rows.length > 1) {
    rows.splice(rows.length - 1, 0, {});
  }

  // If a title is given, leave row 1 empty for it and start the data at row 2
  const worksheet = title
    ? XLSX.utils.json_to_sheet(rows, { origin: "A2" })
    : XLSX.utils.json_to_sheet(rows);

  if (title) {
    // Write the title text into cell A1
    XLSX.utils.sheet_add_aoa(worksheet, [[title]], { origin: "A1" });

    // Merge A1 across all the data columns so it reads as one heading
    const columnCount = jsonData.length > 0 ? Object.keys(jsonData[0]).length : 1;
    worksheet["!merges"] = worksheet["!merges"] || [];
    worksheet["!merges"].push({
      s: { r: 0, c: 0 },
      e: { r: 0, c: columnCount - 1 },
    });

    // Center the heading text (horizontally and vertically) and make it bold
    worksheet["A1"].s = {
      alignment: { horizontal: "center", vertical: "center" },
      font: { bold: true },
    };
  }

  // Create a new workbook and append the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Payroll");

  // Convert workbook to binary array
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

  // Save file
  const data = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(data, `${fileName}.xlsx`);
};
